import "./assets/styles.scss";
import { FollowLink, followLinks } from "../About/assets/followLinks";

export default function Footer(): JSX.Element {
  const renderFollowLinks = () => {
    return followLinks.map((link: FollowLink) => (
      <li className="follow-link">
        <a title={link.title} rel="noreferrer" target="_blank" href={link.href}>
          <i className={link.icon}></i>
        </a>
      </li>
    ));
  };
  return (
    <footer className="footer-container">
      <div className="footer">
        <ul className="follow-links">{renderFollowLinks()}</ul>
        <span className="footer-copyright">
          Alex Bukin &copy; {new Date().getFullYear()}
        </span>
      </div>
    </footer>
  );
}
